import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddButtonComponent } from '../../../../../shared/components/add-button/add-button.component';
import { RewardRule } from '../../../../../rewards/models/rewards-v2.models';
import { formatAdminRewardCriteria } from '../../utils/admin-reward-criteria.util';

@Component({
  selector: 'app-reward-earning-criteria',
  standalone: true,
  imports: [CommonModule, AddButtonComponent],
  templateUrl: './reward-earning-criteria.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./reward-earning-criteria.component.scss'],
})
export class RewardEarningCriteriaComponent {
  @Input() activeRules: RewardRule[] = [];
  @Input() isLoading = false;

  @Output() rewardSettingsClick = new EventEmitter<void>();

  get criteriaText(): string {
    return formatAdminRewardCriteria(this.activeRules);
  }

  onRewardSettingsClick(): void {
    this.rewardSettingsClick.emit();
  }
}
